import { Chip } from "@material-ui/core"
import React from "react"

import {
	DraftsOutlined as DraftIcon,
	MailOutlined as SendIcon,
	ScheduleRounded
} from "@material-ui/icons"
import { fullDatetime } from "@/utils/time"
import { MessageBlastData } from "@/protocols/messageBlast"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

export const renderMessageBlastStatusToMaterialChips = (messageBlast: Partial<MessageBlastData>) => {
	const messageBlastStatus = messageBlast.status || "DRAFT"

	const messageBlastStatusToMaterialChips: Record<string, JSX.Element> = {
		SENT: <Chip
			icon={<SendIcon style={{ marginLeft: "10px" }}/>}
			label={`Envio realizado em: ${messageBlast.statusDate && fullDatetime(new Date(messageBlast.statusDate))}`} style={{ ...ColorUtil.getBackgroundAndContrastColor(colors.green[200]) }}/>,
		SCHEDULED: <Chip
			icon={<ScheduleRounded/>}
			label={`Envio agendado para: ${messageBlast.schedule?.time && fullDatetime(new Date(messageBlast.schedule.time))}`}
			style={{ ...ColorUtil.getBackgroundAndContrastColor(colors.blue[100]) }}
		/>,
		DRAFT: <Chip icon={<DraftIcon style={{ marginLeft: "10px" }}/>} label="Rascunho" style={{ ...ColorUtil.getBackgroundAndContrastColor(colors.red[100]) }}/>
	}

	return messageBlastStatusToMaterialChips[messageBlastStatus]
}

export const messageBlastStatusTranslatedMapCamelCase = {
	DRAFT: "Rascunhos",
	SCHEDULED: "Agendados",
	SENT: "Realizados"
}
